import { SUBGROUPS_WITH_LABEL_NEW } from '../constants';

const checkIsNewSubgroup = (path) =>
  APP_NAME === 'affiliates' &&
  SUBGROUPS_WITH_LABEL_NEW.find(
    (group) =>
      path.includes(group.id) && Date.now() <= group.expiryDate.getTime(),
  );

export default checkIsNewSubgroup;
